import { Button, Dialog, DialogActions, DialogContent, Grid } from "@mui/material";

import { ConfirmProps } from "./types";

export const ConfirmDialog = (props: ConfirmProps) => {
  if (!props.confirmOpen) {
    return null;
  }

  return (
    <Dialog open={props.confirmOpen} onClose={props.onClose}>
      <DialogContent>{props.dialogContent}</DialogContent>
      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="stretch"
          sx={{ gap: 2 }}
          padding={2}
        >
          <Button
            className="button"
            onClick={() => {
              props.onClose ? props.onClose()! : null;
            }}
          >
            Cancel
          </Button>
          <Button
            className="button"
            onClick={() => {
              props.onSubmit ? props.onSubmit()! : null;
            }}
          >
            Confirm
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
